"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cadoneghe": {
    "00f68add": [{
      "hkey": "0b07a375",
      "slug": "mejaniga-castagnara",
      "name": "Mejaniga-Castagnara",
      "primary": true,
      "skipSearch": false
    }],
    "castagnara": [{
      "hkey": "0b07a375",
      "slug": "mejaniga-castagnara",
      "name": "Mejaniga-Castagnara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cadoneghe"
    }],
    "51433c8d": [{
      "hkey": "0b07a375",
      "slug": "mejaniga-castagnara",
      "name": "Mejaniga-Castagnara",
      "primary": true,
      "skipSearch": false
    }],
    "mejaniga": [{
      "hkey": "0b07a375",
      "slug": "mejaniga-castagnara",
      "name": "Mejaniga-Castagnara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;